module.exports = __webpack_public_path__ + "public/images/about-bottom-bg.90b9e73629d95766e3b603798b7aeb4d.svg";